<template>
  <main class="pt-16 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-100 min-h-screen">
    <div class="w-full py-6 sm:py-8 lg:py-16">
      <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 mb-8 text-center">
          Mentions légales
        </h1>

        <div class="bg-white rounded-lg shadow-sm p-6 sm:p-8 space-y-8 text-center">
          <!-- Editeur -->
          <section>
            <h2 class="text-lg font-semibold text-gray-900 underline mb-4">Editeur :</h2>
            <p class="text-gray-700">Modelabs Mobile</p>
            <p class="text-gray-700">107 rue la Boétie</p>
            <p class="text-gray-700">75008 Paris</p>
            <p class="text-gray-700 mt-4">RCS Paris 753107226</p>
          </section>

          <!-- Responsable de traitement -->
          <section>
            <h2 class="text-lg font-semibold text-gray-900 underline mb-4">Responsable de traitement :</h2>
            <p class="text-gray-700">Modelabs Mobile</p>
            <p class="text-gray-700">107 rue la Boétie</p>
            <p class="text-gray-700">75008 Paris</p>
            <p class="text-gray-700 mt-4">RCS Paris 753107226</p>
          </section>

          <!-- Hébergement -->
          <section>
            <h2 class="text-lg font-semibold text-gray-900 underline mb-4">HEBERGEMENT</h2>
            <p class="font-medium text-gray-900 mb-2">Hébergement des données:</p>
            <p class="text-gray-700">Les données sont hébergées dans des</p>
            <p class="text-gray-700">centres de données situés en France</p>
            <p class="text-gray-700">sur des serveurs gérés par MongoDb Limited</p>
            <p class="text-gray-700">Building2 Number One Ballsbridge,</p>
            <p class="text-gray-700">Shelbourne Rd, Dublin 4,</p>
            <p class="text-gray-700">D04 Y3X9, Irlande</p>
            <p class="text-gray-700 mt-4">Téléphone : +35319014654</p>
            <p class="text-gray-700">Email : support@mongodb.com</p>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "MentionsView",
};
</script>
